import { motion } from "framer-motion";

import { cx } from "../../Utils/helpers";

/**
 * Base card surface. Variants control fill; `interactive` adds the
 * lift + gradient-border hover used across Services, Why Us, Industries.
 */
function Card({
  children,
  variant = "glass",
  interactive = false,
  gradientBorder = false,
  as: Tag = "div",
  className,
  ...rest
}) {
  const MotionTag = motion[Tag] || motion.div;

  return (
    <MotionTag
      className={cx(
        "card",
        variant === "solid" && "card--solid",
        variant === "flat" && "card--flat",
        interactive && "card--interactive",
        gradientBorder && "card--gradient-border",
        className
      )}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}

export default Card;
